class AnimatedHeight {
	constructor(el) {
		this.el = el;
		this.init();
	}

	init() {
		this.animLoop();
	}

	animLoop() {
		const fixedHeight = this.el.getAttribute('data-animate-height');
		const $children = Array.from(this.el.children);

		let totalChildHeight = 0;
		$children.forEach($element => {
			totalChildHeight = totalChildHeight + $element.offsetHeight;
		});

		const innerHeight = !isNaN(parseInt(fixedHeight))
			? parseInt(fixedHeight)
			: totalChildHeight;

		const finalHeight = !isNaN(parseInt(innerHeight))
			? parseInt(innerHeight)
			: 'auto';

		this.el.style.height = `${finalHeight}px`;

		requestAnimationFrame(() => {
			this.animLoop();
		});
	}
}

export default AnimatedHeight;
